// extracted by mini-css-extract-plugin
module.exports = {"container":"LegacyLayout_container__mdNZk"};